import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cspondemand',
  templateUrl: './cspondemand.component.html',
  styleUrls: ['./cspondemand.component.css']
})
export class CspondemandComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

}
